export const academicBoard = [
  {
    id: 1,
    name: 'Prof. Dr. Elena Vasquez',
    title: 'Distinguished Professor of Quantum Physics',
    institution: 'MAH Quantum Research Institute',
    category: 'editor',
    role: 'Editor-in-Chief (Sample Role)',
    expertise: ['Quantum Computing', 'Quantum Optics', 'Condensed Matter Physics'],
  },
  {
    id: 2,
    name: 'Prof. Dr. Li Wei',
    title: 'Professor of Computer Science & AI',
    institution: 'MAH Quantum Research Institute',
    category: 'editor',
    role: 'Editor-in-Chief (Sample Role)',
    expertise: ['Artificial Intelligence', 'Deep Learning', 'Natural Language Processing'],
  },
  {
    id: 3,
    name: 'Prof. Dr. Rajesh Kumar',
    title: 'Professor of Materials Engineering',
    institution: 'MAH Quantum Research Institute',
    category: 'editor',
    role: 'Editor-in-Chief (Sample Role)',
    expertise: ['Nanomaterials', 'Smart Materials', 'Functional Coatings'],
  },
  {
    id: 4,
    name: 'Prof. Dr. Amara Osei',
    title: 'Professor of Molecular Biology',
    institution: 'MAH Quantum Research Institute',
    category: 'editor',
    role: 'Editor-in-Chief (Sample Role)',
    expertise: ['Genomics', 'Proteomics', 'CRISPR Technologies'],
  },
  {
    id: 5,
    name: 'Prof. Dr. Klaus Weber',
    title: 'Senior Research Fellow, Theoretical Physics',
    institution: 'MAH Quantum Research Institute',
    category: 'advisor',
    role: 'Advisor (Sample Role)',
    expertise: ['Particle Physics', 'String Theory', 'Mathematical Physics'],
  },
  {
    id: 6,
    name: 'Prof. Dr. Fatima Al-Zahrani',
    title: 'Professor of Computational Biology',
    institution: 'MAH Quantum Research Institute',
    category: 'advisor',
    role: 'Advisor (Sample Role)',
    expertise: ['Computational Biology', 'Systems Biology', 'Bioinformatics'],
  },
  {
    id: 7,
    name: 'Prof. Dr. David Okafor',
    title: 'Professor of Electrical Engineering',
    institution: 'MAH Quantum Research Institute',
    category: 'reviewer',
    role: 'Reviewer (Sample Role)',
    expertise: ['Photonics', 'Semiconductor Devices', 'RF Engineering'],
  },
  {
    id: 8,
    name: 'Prof. Dr. Natasha Ivanova',
    title: 'Research Professor, Applied Mathematics',
    institution: 'MAH Quantum Research Institute',
    category: 'reviewer',
    role: 'Reviewer (Sample Role)',
    expertise: ['Numerical Analysis', 'Optimization Theory', 'Statistical Mechanics'],
  },
  {
    id: 9,
    name: 'Prof. Dr. Carlos Mendez',
    title: 'Professor of Environmental Engineering',
    institution: 'MAH Quantum Research Institute',
    category: 'advisor',
    role: 'Advisor (Sample Role)',
    expertise: ['Environmental Science', 'Sustainable Energy', 'Climate Modeling'],
  },
  {
    id: 10,
    name: 'Prof. Dr. Yuki Tanaka',
    title: 'Professor of Robotics & Autonomous Systems',
    institution: 'MAH Quantum Research Institute',
    category: 'advisor',
    role: 'Advisor (Sample Role)',
    expertise: ['Robotics', 'Control Systems', 'Human-Robot Interaction'],
  },
  {
    id: 11,
    name: 'Prof. Dr. Priya Nair',
    title: 'Senior Lecturer in Biomedical Engineering',
    institution: 'MAH Quantum Research Institute',
    category: 'reviewer',
    role: 'Reviewer (Sample Role)',
    expertise: ['Biomedical Imaging', 'Neural Prosthetics', 'Biosensors'],
  },
  {
    id: 12,
    name: 'Prof. Dr. Omar Farooq',
    title: 'Professor of Data Science',
    institution: 'MAH Quantum Research Institute',
    category: 'reviewer',
    role: 'Reviewer (Sample Role)',
    expertise: ['Data Science', 'Graph Theory', 'Distributed Computing'],
  },
];
